// Awards and recognitions. Replace each entry with real awards.
// Set the array empty if there are none yet — the section will hide itself.

const awards = [
  {
    id: "placeholder-1",
    name: "Award name goes here",
    year: "20XX",
    org: "Awarding organisation",
    note: "One short line on what this was for. Edit me in src/content/awards.js.",
  },
  {
    id: "placeholder-2",
    name: "Award name goes here",
    year: "20XX",
    org: "Awarding organisation",
    note: "One short line on what this was for. Edit me in src/content/awards.js.",
  },
  {
    id: "placeholder-3",
    name: "Award name goes here",
    year: "20XX",
    org: "Awarding organisation",
    note: "One short line on what this was for. Edit me in src/content/awards.js.",
  },
];

export default awards;
